import { Icon } from '@iconify/react';
import { Box, Typography } from '@mui/material';
import './OrderStatusCard.scss';

const OrderStatusCard = () => {
  let orderStatus = [
    {
      orderType: 'Trip Source',
      color: '#05850f'
    },
    {
      orderType: 'Order Delivery',
      // color: '#05850f'
      color: '#1e4c8a'
    },
    {
      orderType: 'Direct Sales',
      color: '#fca100'
      // color: '#1e4c8a'
    },
    {
      orderType: 'Adhoc',
      color: 'red'
    }
    // {
    //   orderType: 'In-transit',
    //   color: '#fca100'
    // }
  ];
  return (
    <Box className='deliverystatus'>
      {orderStatus?.map((item: any) => (
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Icon icon='material-symbols-light:circle' color={item?.color} />
          <Typography>{item?.orderType}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default OrderStatusCard;
